import React from "react";

import MapMarkerMD from "@busbud/design-system-components/dist/Icons/MapMarker/MD";
import Label from "@busbud/design-system-components/dist/Label";
import type { VehicleType } from "@busbud/int-schemas/lib/vehicles";

import { useAppContext } from "@app/helpers/hooks";
import { removeTimeOffset } from "@app/helpers/time";

import type { ArrivalStop as ArrivalStopType } from "../types";

import { getDayDifference } from "../../../helpers/date-helper";
import { GenericStop } from "../generic-stop";

interface Props {
  hide_time?: boolean;
  leg_departure_time: string | null;
  stop: ArrivalStopType;
  vehicle_type?: VehicleType;
}

export const ArrivalStop: React.FC<Props> = ({
  leg_departure_time,
  hide_time,
  stop,
  vehicle_type
}) => {
  const { intlProvider, translator } = useAppContext();

  let day_difference: number | null = null;
  if (leg_departure_time && stop.arrival_time) {
    day_difference = getDayDifference(
      removeTimeOffset(leg_departure_time),
      removeTimeOffset(stop.arrival_time)
    );
  }

  return (
    <GenericStop
      day_difference={day_difference}
      has_line={false}
      has_indent={false}
      hide_time={hide_time}
      time={stop.arrival_time}
      name={stop.arrival_name}
      city_name={stop.arrival_city_name}
      lat={stop.arrival_lat}
      lon={stop.arrival_lon}
      duration={stop.duration}
      vehicle_type={vehicle_type}
      icon={<MapMarkerMD color="accent.secondary.400" />}
      stop_location_type={stop.stop_location_type}
    >
      {!!stop.arrival_time && !!day_difference && day_difference > 0 && (
        <Label
          component="div"
          color="text.negative.translucent"
          fontWeight="bold"
          size="sm"
        >
          {/*
            TODO: wrap `arrival_day` in `time` tag:
            https://github.com/busbud/public-website/issues/18360
          */}
          {translator.t("!itinerary.location.arrives-future-day", {
            date: intlProvider.formatDate(stop.arrival_time, {
              month: "short",
              day: "numeric",
              weekday: "long"
            })
          })}
        </Label>
      )}
    </GenericStop>
  );
};
